<div class="gd-global-material-dialog-padding tw-h-full tw-overflow-y-auto tw-pt-0 gd-custom-scroller">
  @if (quickViewArticle$ && quickViewArticle$.revision && quickViewArticle$.body) {
    <div class="gd-quick-view tw-flex tw-flex-col"
      [dir]="dir$ | async">
      <div class="tw-flex tw-flex-col">
        <div class="gd-quick-view-sticky">
          <h2
          class="gd-quick-view__headline mat-h2">{{quickViewArticle$.revision.headline}}</h2>
          @if (quickViewArticle$.revision.catchline) {
            <h5 class="gd-quick-view__catchline"
            >{{quickViewArticle$.revision.catchline}}</h5>
          }
        </div>
        <div class="gd-quick-view-additional-details tw-flex tw-flex-row tw-justify-between tw-items-start">
          <div>
            @if (quickViewArticle$.revision.authors; as authors) {
              <div class="gd-quick-view-additional-details-item tw-flex tw-flex-row tw-justify-start tw-items-start"
                >
                <div class="gd-quick-view-additional-details-label"><ng-container i18n>Author</ng-container>:</div>
                <div class="gd-quick-view-additional-details-authors">
                  @for (author of authors; let i=$index; track author) {
                    <span>
                      {{author.name}}
                      @if ((authors.length - 1) !== i) {
                        <span>,</span>
                      }
                    </span>
                  }
                </div>
              </div>
            }
            @if (quickViewArticle$.revision.status; as status) {
              <div class="gd-quick-view-additional-details-item tw-flex tw-flex-row tw-justify-start tw-items-center"
                >
                <div class="gd-quick-view-additional-details-label"><ng-container i18n>Status</ng-container>:</div>
                <div class="status-label-wrapper">
                  <div i18n="@@statusList">{status?.name, select, Published {Published} Ready {Ready} Review {Review} Scheduled {Scheduled} Unpublished {Unpublished} Draft {Draft} other { {{status?.name}} } }</div>
                  <div class="status-color --select-value"
                    [style.backgroundColor]="status.backgroundColor">
                    {{status.name.charAt(0)}}
                  </div>
                </div>
              </div>
            }
            @if (quickViewArticle$.revision.status; as status) {
              <div class="gd-quick-view-additional-details-item tw-flex tw-flex-row tw-justify-start tw-items-center"
                >
                <div class="gd-quick-view-additional-details-label">
                  @if (status.published) {
                    <span i18n>Published time: {{quickViewArticle$.revision.date}}</span>
                  }
                  @if (!status.published) {
                    <span i18n>Edit time: {{quickViewArticle$.revision.date}}</span>
                  }
                </div>
              </div>
            }
            @if (quickViewArticle$.revision.taxonomies || quickViewArticle$.revision.primaryTaxonomyId) {
              <div class="gd-quick-view-additional-details-item tw-flex tw-flex-row tw-justify-start tw-items-start"
                >
                <div class="gd-quick-view-additional-details-label"><ng-container i18n>Taxonomies</ng-container>:</div>
                  @if (quickViewArticle$.revision.taxonomies.length) {
                    <gd-chip-list [items]="quickViewArticle$.revision.taxonomies"
                      [resource]="quickViewArticle$.revision"
                      [width]="500"
                      [visibleRows]="10">
                    </gd-chip-list>
                  }
                </div>
            }
          </div>
          <div class="gd-quick-view-additional-details-item tw-flex tw-flex-row tw-justify-start tw-items-start">
            @if (quickViewArticle$.revision.promoImage; as promoImage) {
              <div class="gd-promo-image__image-wrapper"
                >
                <img class="promo-image --card"
                  [src]="promoImage">
                </div>
              }
            </div>
          </div>
          <mat-divider></mat-divider>

        <div class="tw-flex">
          <div class="gd-quick-view-content fr-wrapper tw-w-full">
            <div class="fr-box fr-basic fr-top">
              <div class="fr-element fr-view"
                [innerHtml]="quickViewArticle$.body">
              </div>
            </div>
          </div>
          @if ((loading$ | async) !== true) {
            <button
              mat-raised-button
              class="gd-quick-view-modal__cancel-btn --margin"
              i18n
            (click)="closeDialog()">Close</button>
          }
        </div>
      </div>
      </div>
    }
  </div>
